import React, { memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import EvalRadio from "./EvalRadio";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  contents: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    width: "100%",
    marginBottom: 12,
  },
  body: {
    backgroundColor: "#ffffff",
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    paddingLeft: theme.spacing(4.75),
    paddingRight: theme.spacing(4.75),
    border: "1px solid #e0ebff",
  },
  form: {
    marginTop: 12,
  },
}));

const EvalList = memo(({ data, que, handleChange }) => {
  const classes = useStyles();
  return (
    <Grid className={classes.contents}>
      <Grid className={classes.body}>
        <Typography variant="h4" className={classes.title}>
          {data.no}. {data.text}
        </Typography>
        <Grid
          container
          direction={data.no === 4 ? "column" : "row"}
          justify="space-around"
          className={classes.form}
        >
          {data.list.map((ldata, index) => (
            <EvalRadio
              key={index}
              data={data}
              index={index}
              ldata={ldata}
              que={que}
              handleChange={handleChange}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
});

export default EvalList;
